import { TopicId } from '~/dashboard/utils/learningPath.utils'

import AnalyticsEvents_V2 from '../analyticsGA4'
import { PortalProducts } from '../types/analytics.type'

import { BootcampEvents, BootcampPathObject } from './bootcampEvents.types'

class BootcampAnalytics extends AnalyticsEvents_V2 {
  public constructor() {
    super(PortalProducts.VCC)
  }
  /**
   * Generic Logger
   * @param eventAction
   * @param eventLabel
   * @param eventValue
   */
  public log(event: BootcampEvents, eventParams: BootcampPathObject): void {
    this.logEvent({ event, ...eventParams })
  }

  /**
   * Log gamification related Data.
   * @param eventLabel
   * @param gemType
   * @param mathOrbs
   */
  public logGamification(eventParams: BootcampPathObject, gemCount: number, xpCount: number, mathOrbs = 0): void {
    this.logRewards({
      title: PortalProducts.VCC,
      gems: gemCount || 0,
      experience_points: xpCount || 0,
      kudos: mathOrbs || 0,
      ...eventParams,
    })
  }

  /**
   * Log Help Button Click
   * @param eventLabel //Event Label
   */

  public logClickHelpButton(eventParams: BootcampPathObject): void {
    this.logEvent({ event: BootcampEvents.CLICKED_HELP, ...eventParams })
  }

  /**
   * Log Prerequisites Dropdown Open/Closed
   * @param eventLabel //Event Label
   */

  public logClickPrerequisitesDropdown(eventParams: BootcampPathObject): void {
    this.logEvent({ event: BootcampEvents.CLICKED_PREREQUISITES_DROPDOWN, ...eventParams })
  }

  /**
   * Log Activity Menu Dropdown Open/Closed
   * @param eventLabel //Event Label
   */

  public logClickActivityMenu(eventParams: BootcampPathObject): void {
    this.logEvent({ event: BootcampEvents.CLICKED_ACTIVITY_MENU_DROPDOWN, ...eventParams })
  }

  public logSelectTopic(topic: TopicId): void {
    this.logEvent({
      event: BootcampEvents.SELECTED_TOPIC,
      topic,
    })
  }

  public logToggleSwitch(from: string, to: string): void {
    this.logEvent({
      event: BootcampEvents.TOGGLE_SWITCH,
      from,
      to,
    })
  }
}

export default new BootcampAnalytics()
